<template>
<div>
  <div class="col-12"><h2>Positive Actions</h2></div>
<v-sheet
    class="ml-20"
    max-width="150%"

  >
    <v-slide-group
      v-model="model"
      show-arrows
      hide-dilimeters
    >
      <v-slide-item
        v-for="category in categories"
        :key="category"
        v-slot="{ active, toggle }"
      >
        <v-btn
          class="mx-2"
          :input-value="active"
          active-class="purple white--text"
          depressed
          rounded
          @click="toggle"
        >
          {{category }}
        </v-btn>
      </v-slide-item>
    </v-slide-group>
  </v-sheet> 
<v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          class="mt-10"
          dark
          style="width: 22%"
          v-bind="attrs"
          v-on="on"
          rounded
        >
          Add new postive action
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Positive Action</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Action ID*"
                  required
                  
                  v-model="userId"
                ></v-text-field>
                <v-text-field
                  label="Action*"
                  required
                  v-model="action"
                ></v-text-field>

                
                <v-text-field
                  label="Timestamp*"
                  required
                  v-model="timestamp"
                ></v-text-field>
                
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Tracks*"
                  required
                  type="number"
                  v-model="tracks"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                 <v-select
                  :items="categoriess"
                   v-model="selected_category"
                  label="Category"
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="12">
                 <v-checkbox
                  v-model="checkbox"
                  label="is active"
                  
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="save"
            :loading="loading"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  <v-row class="mt-5">
    <v-col sm="12" md="6" v-for="(item, index) in positiveActions" :key="index">
    <v-card
    >
      <v-card-title class="text-h6">
        {{item.action}}
      </v-card-title>

      <v-chip class="ma-2">
        {{item.tracks}}  poeple did this
      </v-chip>
    </v-card>
    </v-col>
</v-row>

</div>

</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";

export default {
  async created() {
    await this.fetchAllPositiveActions();
    this.positiveActions = this.allPositiveActions
    this.model = 0
  },
    computed: {
  ...mapFields("positive_action", ["allPositiveActions"]),
  },
      methods: {
    ...mapActions("positive_action", ["fetchAllPositiveActions", "addPositiveAction"]),
      async save() {
        this.loading = true;
        await this.addPositiveAction({

        // convert timestamp to timestamp
        

          action: this.action,
          // convert to timestamp 
          
          timestamp: this.timestamp,
          userId: this.userId,
          category: this.selected_category,
          isActive: this.checkbox,
          
          tracks: parseInt(this.tracks)
          
        });
        await this.fetchAllPositiveActions();
        this.positiveActions = this.allPositiveActions
        this.model = 0

        this.loading = false;
        this.dialog = false;
    },
    },
    watch: {
      model:{
      immidate: true,
      handler: async function(value) {
        let category_name = ""
        if (value == 0) {
          this.positiveActions = this.allPositiveActions
        }

        else{
          if (value == 1) {
            category_name = "wellness"
          }
          if (value == 2) {
            category_name = "health"
          }
          if (value == 3) {
            category_name = "growth"
          }
          if (value == 4) {
            category_name = "connection"
          }
          this.positiveActions = this.allPositiveActions.filter(item => item.category == category_name);

        }

      }
    },
      },
    data() {
    return {
      positiveActions: null,
      dialog: false,
      model: null,
      categories: ["all", "wellness", "health", "growth", "connection"],
      categoriess: ["wellness", "health", "growth", "connection"],
      checkbox: true,
      action: "",
      timestamp: "",
      userId: "",
      tracks: 0,
      selected_category: null,
      loading: false,
      // generate random number 16 digits and characters
      randomString() {
        var result = "";
        var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charactersLength = characters.length;
        for (var i = 0; i < 16; i++) {
          result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
          );
        }
        return result;
      },

    };
  }
}
</script>
